import { v4 as uuidv4 } from 'uuid';
import { addLogToReport } from '@americanexpress/one-app-ducks';
import { getClientContext } from '../utils/deviceUtils';

/**
 * Calls ReadUserSession.v1 and returns true if the session is authenticated
 * (HTTP 200), false otherwise. Network errors are treated as unauthenticated.
 */
export const readUserSession = async (readUserSessionApiUrl, dispatch) => {
  const correlationId = uuidv4();
  try {
    const response = await fetch(readUserSessionApiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'one-data-correlation-id': correlationId,
      },
    });

    const isAuthenticated = response.status === 200;

    dispatch(addLogToReport('info', 'ReadUserSession response', {
      moduleID: 'axp-bank-permissions-dashboard-root',
      status: response.status,
      isAuthenticated,
      correlationId,
      ...getClientContext(),
    }));

    return isAuthenticated;
  } catch (err) {
    dispatch(addLogToReport('warn', 'ReadUserSession call failed', {
      moduleID: 'axp-bank-permissions-dashboard-root',
      message: String(err),
      correlationId,
      ...getClientContext(),
    }));

    return false;
  }
};
